/* eslint-disable */
import axios from 'axios'
import { ServerConfig } from '../config';

const instance = axios.create({
    baseURL: ServerConfig.API_URL
})

instance.interceptors.response.use((response) => {
    return response;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
    }
    return Promise.reject(error);
})

export const setToken = (token: string | null) => {
    if (token) {
        instance.defaults.headers.common.Authorization = 'Bearer ' + token;
    }
}

export const HttpClient = instance